import { Color, getDefaultTransition, rwd } from '@billy/design-system'
import styled from '@emotion/styled'

export const DrawerBackgroundWrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: ${Color.Grey100};
`

export const ContentArea = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: ${Color.White};
  ${getDefaultTransition('clip-path')};

  ${rwd.greaterThan('xxxlarge')} {
    clip-path: inset(0 0 0 0 round 0 var(--drawer-border-radius, 0px) var(--drawer-border-radius, 0px) 0);
  }
`
